import { render } from "./FigAnim.vue?vue&type=template&id=54d252b7&scoped=true"
import script from "./FigAnim.vue?vue&type=script&lang=js"
export * from "./FigAnim.vue?vue&type=script&lang=js"

import "./FigAnim.vue?vue&type=style&index=0&id=54d252b7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d252b7"]])

export default __exports__